import React from "react";

export default class PageNotFound extends React.Component {
    public render() {
        return (<div> Page not found </div>);
    }
}